import React from 'react';
import CreateEditAdditionalInfoModal from './CreateEditAdditionalInfoModal';
import {currentResource} from '../../../../../../util/utils';

export default function AdditionalInfoWrapper({
	sampleDataItem,
	isCreate = false,
	isEdit = false,
	isRemove = false,
	showModal,
	setShowModal,
	sampleItemId,
	sampleListId,
	selectedAttributeStatusId,
	onHideModal,
	isRemoveAttributesRequired
}) {
	const additionDocumentationLabels = currentResource.AdditionDocumentationLabels;
	return (
		<>
			{isCreate && (
				<CreateEditAdditionalInfoModal
					isCreate={isCreate}
					sampleDataItem={sampleDataItem}
					showModal={showModal}
					setShowModal={setShowModal}
					isRemove={isRemove}
					sampleItemId={sampleItemId}
					sampleListId={sampleListId}
					selectedAttributeStatusId={selectedAttributeStatusId}
					onHideModal={onHideModal}
					isRemoveAttributesRequired={isRemoveAttributesRequired}
					modalTitle={additionDocumentationLabels.addAdditionalDocumentation}
				/>
			)}
			{isEdit && (
				<CreateEditAdditionalInfoModal
					isEdit={isEdit}
					sampleDataItem={sampleDataItem}
					showModal={showModal}
					setShowModal={setShowModal}
					isRemove={isRemove}
					sampleItemId={sampleItemId}
					sampleListId={sampleListId}
					selectedAttributeStatusId={selectedAttributeStatusId}
					onHideModal={onHideModal}
					isRemoveAttributesRequired={isRemoveAttributesRequired}
					modalTitle={additionDocumentationLabels.editAdditionalDocTitle}
				/>
			)}
		</>
	);
}
